import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideSectionLabel,
  GuideCard,
  GuideCardGrid,
  GuideBlockList,
} from "../GuideBlocks.js";

const EvidenceBasedThinkingSection = ({ heading, accentIndex = 0, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="evidence-based-thinking"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      Once your mind creates a story, pause and ask a simple question:{" "}
      <strong>"What evidence do I have?"</strong>
    </GuideLead>
    <p className="guide-panel__p">
      Evidence-based thinking encourages us to test our assumptions instead of accepting them
      automatically.
    </p>
    <GuideSectionLabel>Ask yourself</GuideSectionLabel>
    <GuideBlockList
      items={[
        "What facts support this thought?",
        "What facts contradict it?",
        "Am I making assumptions?",
        "Would another person reach the same conclusion using the same facts?",
      ]}
    />
    <GuideSectionLabel>Example: "My colleague is ignoring me."</GuideSectionLabel>
    <GuideCardGrid columns={2}>
      <GuideCard iconKey="clarity" title="Evidence">
        <GuideBlockList items={["They have not replied for one day.", "They attended meetings today."]} />
      </GuideCard>
      <GuideCard iconKey="thinking" title="Missing evidence">
        <GuideBlockList
          items={[
            "You don't know if they saw the email.",
            "You don't know if they are busy.",
            "You don't know their priorities today.",
          ]}
        />
      </GuideCard>
    </GuideCardGrid>
    <GuideCallout>
      Evidence often reveals that certainty is much lower than our emotions suggest. This shift creates
      mental clarity and reduces unnecessary anxiety.
    </GuideCallout>
  </GuidePanel>
);

export default EvidenceBasedThinkingSection;
